/** 求助请求的本地命令结果共享最高版本；相同版本默认不覆盖；业务 owner 只能补充同版本的安全内存投影。 */
export function mergeCardSnapshots<
  T,
  C extends { card_id: string; version: number },
>(
  previous: T[],
  incoming: T[],
  updates: C[],
  cards: (row: T) => C[] | undefined,
  replace: (row: T, cards: C[]) => T,
  preferSameVersion?: (previous: C, incoming: C) => boolean,
): T[] {
  const latest = new Map<string, C>();
  for (const card of [
    ...previous.flatMap((row) => cards(row) ?? []),
    ...updates,
    ...incoming.flatMap((row) => cards(row) ?? []),
  ]) {
    const prior = latest.get(card.card_id);
    if (
      card.version > (prior?.version ?? 0) ||
      (prior?.version === card.version && preferSameVersion?.(prior, card))
    )
      latest.set(card.card_id, card);
  }
  return incoming.map((row) => {
    const current = cards(row);
    return current
      ? replace(
          row,
          current.map((card) => latest.get(card.card_id) ?? card),
        )
      : row;
  });
}

/** 先收到更新再收到原消息时也保留清理版本。 */
export function rememberSupportSnapshot<
  C extends { card_id: string; version: number },
>(previous: C[] | undefined, card: C) {
  const prior = previous?.find((item) => item.card_id === card.card_id);
  if (prior && prior.version >= card.version) return previous;
  return [
    ...(previous ?? []).filter((item) => item.card_id !== card.card_id),
    card,
  ];
}
